var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDoctorDash03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.875 12.5C9.29125 12.5 11.25 10.5412 11.25 8.125C11.25 5.70875 9.29125 3.75 6.875 3.75C4.45875 3.75 2.5 5.70875 2.5 8.125C2.5 10.5412 4.45875 12.5 6.875 12.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.875 26.25C9.29125 26.25 11.25 24.2912 11.25 21.875C11.25 19.4588 9.29125 17.5 6.875 17.5C4.45875 17.5 2.5 19.4588 2.5 21.875C2.5 24.2912 4.45875 26.25 6.875 26.25Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M19.0628 14.9753L28.0628 8.25034C28.4753 7.93784 28.5628 7.35034 28.2503 6.93784C27.9378 6.52534 27.3503 6.43784 26.9378 6.75034L17.5003 13.8128L10.5628 8.62534C10.1503 8.31284 9.56282 8.40034 9.25032 8.81284C8.93782 9.22534 9.02531 9.81284 9.43781 10.1253L15.9378 14.9878L8.56284 20.5128C8.15034 20.8253 8.06284 21.4128 8.37534 21.8253C8.56284 22.0753 8.83781 22.2003 9.12531 22.2003C9.32531 22.2003 9.51283 22.1378 9.68783 22.0128L17.5128 16.1628L26.9503 23.2253C27.1128 23.3503 27.3128 23.4128 27.5128 23.4128C27.8003 23.4128 28.0753 23.2878 28.2628 23.0378C28.5753 22.6253 28.4878 22.0378 28.0753 21.7253L19.0628 14.9753Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoctorDash03);
export default __webpack_public_path__ + "static/media/doctor-dash-03.6040beed9d2189997f781187490d39c1.svg";
export { ForwardRef as ReactComponent };